<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <ListingComponent class="bg-white"
                      :showChatIdFilter="true"
                      :requestProvider="requestProvider"
                      :columnConfig="columnConfig">
    </ListingComponent>
  </div>
</template>

<script>
import ListingComponent from '@/components/listing/ListingComponent'
import moment from 'moment'

export default {
  name: 'QuizUserTriesListPage',
  beforeRouteEnter (to, from, next) {
    if (to.params.quizId && !isNaN(to.params.quizId)) {
      next()
    } else {
      next(from.path)
    }
  },
  data () {
    return {
      columnConfig: [
        {
          columnCode: 'action',
          columnName: 'Action',
          value: (item) => {
            return (
              <b-dropdown variant="link" class="listing-action">
                <b-dropdown-item href={'#/quiz/user-tries/' + this.$route.params.quizId + '/summary/' + item.id}>Summary</b-dropdown-item>
              </b-dropdown>
            )
          }
        },
        {
          columnCode: 'chatId',
          columnName: 'Chat ID',
          align: 'left',
          value: item => {
            return item.telegramMember ? item.telegramMember.chatId : ''
          }
        },
        {
          columnCode: 'username',
          columnName: 'Username',
          align: 'left',
          value: item => {
            return item.telegramMember ? item.telegramMember.username : ''
          }
        },
        {
          columnCode: 'firstName',
          columnName: 'First Name',
          align: 'left',
          value: item => {
            return item.telegramMember ? item.telegramMember.firstName : ''
          }
        },
        {
          columnCode: 'lastName',
          columnName: 'Last Name',
          align: 'left',
          value: item => {
            return item.telegramMember ? item.telegramMember.lastName : ''
          }
        },
        {
          columnCode: 'phone',
          columnName: 'Phone',
          align: 'left',
          value: item => {
            return item.telegramMember ? item.telegramMember.phone : ''
          }
        },
        {
          columnCode: 'statusCode',
          columnName: 'Status',
          align: 'left',
          value: item => {
            return item.statusCode ? item.statusCode : ''
          }
        },
        {
          columnCode: 'totalPoint',
          columnName: 'Total Point',
          align: 'left',
          value: item => {
            return item.totalPoint ? item.totalPoint : 0
          }
        },
        {
          columnCode: 'totalDuration',
          columnName: 'Total Duration',
          align: 'left',
          value: item => {
            return item.totalDuration ? item.totalDuration : 0
          }
        },
        {
          columnCode: 'createdDate',
          columnName: 'Created Date',
          align: 'left',
          value: item => {
            return item.createdDate ? moment(item.createdDate).format('YYYY-MM-DD HH:mm:ss') : ''
          }
        },
        {
          columnCode: 'completedDate',
          columnName: 'Completed Date',
          align: 'left',
          value: item => {
            return item.completedDate ? moment(item.completedDate).format('YYYY-MM-DD HH:mm:ss') : ''
          }
        }
      ]
    }
  },
  methods: {
    requestProvider (payload) {
      payload.params.quizId = this.$route.params.quizId
      return this.axios.get('quiz-member/list', payload)
    }
  },
  components: {
    ListingComponent
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/quiz/QuizUserTriesListPage.vue